export default __webpack_public_path__ + "static/media/stamp10.65dc9653.png";